import {UserSource} from "../../tracking/tracking_utils/user_source";
import {AmplitudeAuthMethod} from "../../tracking/types/AmplitudeAuthMethod";
import {AmplitudeAuthPlacement} from "../../tracking/types/AmplitudeAuthPlacement";
import {AuthActionType} from "../types/AuthActionType";
import {authAnalytics, GAAuthEventCategory, GAAuthEventName} from "./auth_analytics";
import {AmplitudeAuthLocation, trackAmplitudeAuthEvent} from "./track_amplitude_auth_event";

export type AuthSuccessMethod = "email" | "google" | "facebook" | "google_one_tap";

export interface IAuthSuccessTrackingParams {
    method: AuthSuccessMethod;
    authActionType: AuthActionType;
    userSource: UserSource;
    gtmSourceSection?: string;
    placement: AmplitudeAuthPlacement | null;
    location: AmplitudeAuthLocation;
    authPlacement?: AmplitudeAuthPlacement | null;
}

const amplitudeAuthMethods: Record<AuthSuccessMethod, AmplitudeAuthMethod> = {
    email: "internal",
    google: "google",
    facebook: "facebook",
    google_one_tap: "google_popup"
};

const trackGtmAuthSuccess = (params: IAuthSuccessTrackingParams) => {
    const isNewUser = params.authActionType === AuthActionType.REGISTRATION;
    const event = isNewUser ? GAAuthEventName.SIGN_UP : GAAuthEventName.LOGIN;
    const source = params.gtmSourceSection ?? null;
    const {userSource} = params;

    if (params.method === "google_one_tap") {
        authAnalytics.gtm.googleAuthEvent({event, eventCategory: GAAuthEventCategory.GOOGLE_ONE_TAP, source, userSource});
        return;
    }

    const eventCategory = isNewUser ? GAAuthEventCategory.REGISTRATION_FORM : GAAuthEventCategory.LOGIN_FORM;

    switch (params.method) {
        case "google":
            authAnalytics.gtm.googleAuthEvent({event, eventCategory, source, userSource});
            return;
        case "facebook":
            authAnalytics.gtm.facebookAuthEvent({event, eventCategory, source, userSource});
            return;
        case "email":
            authAnalytics.gtm.emailAuthEvent({event, eventCategory, source, userSource});
            return;
    }
};

const trackAmplitudeAuthSuccess = (params: IAuthSuccessTrackingParams) => {
    const {placement, location, authPlacement} = params;
    const method = amplitudeAuthMethods[params.method];

    if (params.authActionType === AuthActionType.REGISTRATION) {
        trackAmplitudeAuthEvent("signed_up", {signUpMethod: method, signUpPlacement: placement, location, authPlacement});
    } else {
        trackAmplitudeAuthEvent("logged_in", {loginMethod: method, loginPlacement: placement, location, authPlacement});
    }
};

export const trackAuthSuccess = (params: IAuthSuccessTrackingParams) => {
    trackGtmAuthSuccess(params);
    trackAmplitudeAuthSuccess(params);
};
import {UserSource} from "../../tracking/tracking_utils/user_source";
import {AmplitudeAuthMethod} from "../../tracking/types/AmplitudeAuthMethod";
import {AmplitudeAuthPlacement} from "../../tracking/types/AmplitudeAuthPlacement";
import {AuthActionType} from "../types/AuthActionType";
import {authAnalytics, GAAuthEventCategory, GAAuthEventName} from "./auth_analytics";
import {AmplitudeAuthLocation, trackAmplitudeAuthEvent} from "./track_amplitude_auth_event";

export type AuthSuccessMethod = "email" | "google" | "facebook" | "google_one_tap";

export interface IAuthSuccessTrackingParams {
    method: AuthSuccessMethod;
    authActionType: AuthActionType;
    userSource: UserSource;
    gtmSourceSection?: string;
    placement: AmplitudeAuthPlacement | null;
    location: AmplitudeAuthLocation;
    authPlacement?: AmplitudeAuthPlacement | null;
}

const amplitudeAuthMethods: Record<AuthSuccessMethod, AmplitudeAuthMethod> = {
    email: "internal",
    google: "google",
    facebook: "facebook",
    google_one_tap: "google_popup"
};

const trackGtmAuthSuccess = (params: IAuthSuccessTrackingParams) => {
    const isNewUser = params.authActionType === AuthActionType.REGISTRATION;
    const event = isNewUser ? GAAuthEventName.SIGN_UP : GAAuthEventName.LOGIN;
    const source = params.gtmSourceSection ?? null;
    const {userSource} = params;

    if (params.method === "google_one_tap") {
        authAnalytics.gtm.googleAuthEvent({event, eventCategory: GAAuthEventCategory.GOOGLE_ONE_TAP, source, userSource});
        return;
    }

    const eventCategory = isNewUser ? GAAuthEventCategory.REGISTRATION_FORM : GAAuthEventCategory.LOGIN_FORM;

    switch (params.method) {
        case "google":
            authAnalytics.gtm.googleAuthEvent({event, eventCategory, source, userSource});
            return;
        case "facebook":
            authAnalytics.gtm.facebookAuthEvent({event, eventCategory, source, userSource});
            return;
        case "email":
            authAnalytics.gtm.emailAuthEvent({event, eventCategory, source, userSource});
            return;
    }
};

const trackAmplitudeAuthSuccess = (params: IAuthSuccessTrackingParams) => {
    const {placement, location, authPlacement} = params;
    const method = amplitudeAuthMethods[params.method];

    if (params.authActionType === AuthActionType.REGISTRATION) {
        trackAmplitudeAuthEvent("signed_up", {signUpMethod: method, signUpPlacement: placement, location, authPlacement});
    } else {
        trackAmplitudeAuthEvent("logged_in", {loginMethod: method, loginPlacement: placement, location, authPlacement});
    }
};

export const trackAuthSuccess = (params: IAuthSuccessTrackingParams) => {
    trackGtmAuthSuccess(params);
    trackAmplitudeAuthSuccess(params);
};
